"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));
var _Popover = _interopRequireDefault(require("@airasia/phoenix-components/components/Popover"));
var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));
var _RoomCard = require("./RoomCard.propTypes");
var _Clock = _interopRequireDefault(require("./Clock"));
var _TrendingDown = _interopRequireDefault(require("./TrendingDown"));
var _Utils = require("./Utils");
var _constants = require("./constants");
var _BogoIcon = _interopRequireDefault(require("../HotelCard/BogoIcon"));
var _SellIcon = _interopRequireDefault(require("./assets/SellIcon"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable react/prop-types */

var OptionsAndBenefitsWrapper = _styledComponents.default.div.withConfig({
  displayName: "OptionsAndBenefitsInfo__OptionsAndBenefitsWrapper",
  componentId: "sc-gpzfpd-0"
})(["display:", ";flex-direction:column;padding:", ";", ";vertical-align:", ";", ";"], function (_ref) {
  var isMobile = _ref.isMobile;
  return !isMobile ? 'flex' : 'flex';
}, function (_ref2) {
  var theme = _ref2.theme,
    isMobile = _ref2.isMobile;
  return !isMobile ? "16px ".concat(theme.space.standard) : 0;
}, function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile ? 'flex-direction: column' : '';
}, function (_ref4) {
  var isMobile = _ref4.isMobile;
  return !isMobile ? 'top' : '';
}, function (_ref5) {
  var isMobile = _ref5.isMobile;
  return isMobile ? 'width: 100%' : '';
});
var RateOrderWrapper = _styledComponents.default.div.withConfig({
  displayName: "OptionsAndBenefitsInfo__RateOrderWrapper",
  componentId: "sc-gpzfpd-1"
})(["display:flex;margin-bottom:", ";align-items:center;"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.space.tiny;
});
var RateOrder = _styledComponents.default.div.withConfig({
  displayName: "OptionsAndBenefitsInfo__RateOrder",
  componentId: "sc-gpzfpd-2"
})(["font-size:", ";font-weight:", ";line-height:", ";color:", ";margin-right:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSize.normal;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontWeight.medium;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.lineHeight.XLarge;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.neutral;
}, function (_ref11) {
  var theme = _ref11.theme,
    isHasTag = _ref11.isHasTag,
    isMobile = _ref11.isMobile;
  return (
    // eslint-disable-next-line no-nested-ternary
    isHasTag ? isMobile ? theme.space.tiny : theme.space.XSmall : 0
  );
});
var Content = _styledComponents.default.div.withConfig({
  displayName: "OptionsAndBenefitsInfo__Content",
  componentId: "sc-gpzfpd-3"
})(["font-family:", ";font-size:", ";font-weight:", ";line-height:", ";color:", ";margin-top:", ";"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.fontFamily.default;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.fontSize.small;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.fontWeight.normal;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.lineHeight.semiLarge;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.greyDarker;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.space.micro;
});
var TagWrapper = _styledComponents.default.div.withConfig({
  displayName: "OptionsAndBenefitsInfo__TagWrapper",
  componentId: "sc-gpzfpd-4"
})(["background-color:", ";color:", ";padding:", ";font-size:", ";line-height:", ";border-radius:", ";font-weight:", ";margin-right:", ";"], function (_ref18) {
  var theme = _ref18.theme,
    backgroundColor = _ref18.backgroundColor;
  return !backgroundColor ? theme.backgroundColor.blueLight : theme.backgroundColor[backgroundColor];
}, function (_ref19) {
  var theme = _ref19.theme,
    color = _ref19.color;
  return !color ? theme.colors.secondary : theme.colors[color];
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.space.micro;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.fontSize.XSmall;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.lineHeight.small;
}, function (_ref23) {
  var theme = _ref23.theme,
    borderRadius = _ref23.borderRadius;
  return !borderRadius ? theme.borderRadius.normal : theme.borderRadius[borderRadius];
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.fontWeight.medium;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.space.micro;
});
var Promo = _styledComponents.default.div.withConfig({
  displayName: "OptionsAndBenefitsInfo__Promo",
  componentId: "sc-gpzfpd-5"
})(["height:40%;color:", ";display:flex;flex-direction:column;justify-content:center;margin-top:20px;padding-bottom:", ";"], function (_ref26) {
  var theme = _ref26.theme,
    color = _ref26.color;
  return theme.colors[color];
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.space.small;
});
var PromoTag = _styledComponents.default.div.withConfig({
  displayName: "OptionsAndBenefitsInfo__PromoTag",
  componentId: "sc-gpzfpd-6"
})(["display:flex;background:", ";color:", ";min-width:81px;height:21px;font-style:normal;font-weight:bold;font-size:", ";line-height:180%;padding:", ";"], function (_ref28) {
  var theme = _ref28.theme,
    background = _ref28.background;
  return theme.colors[background];
}, function (_ref29) {
  var theme = _ref29.theme,
    color = _ref29.color;
  return theme.colors[color];
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.fontSize.XSmall;
}, function (_ref31) {
  var theme = _ref31.theme;
  return "".concat(theme.space.micro, " ").concat(theme.space.small);
});
var PromoTagMobile = _styledComponents.default.div.withConfig({
  displayName: "OptionsAndBenefitsInfo__PromoTagMobile",
  componentId: "sc-gpzfpd-7"
})(["display:flex;background:", ";color:", ";font-style:normal;margin-left:", ";font-size:", ";display:flex;padding:", ";font-size:", ";"], function (_ref32) {
  var theme = _ref32.theme,
    background = _ref32.background;
  return theme.backgroundColor[background];
}, function (_ref33) {
  var theme = _ref33.theme,
    color = _ref33.color;
  return theme.colors[color];
}, function (_ref34) {
  var theme = _ref34.theme,
    space = _ref34.space;
  return theme.space[space];
}, function (_ref35) {
  var theme = _ref35.theme;
  return theme.space.micro;
}, function (_ref36) {
  var theme = _ref36.theme;
  return theme.space.micro;
}, function (_ref37) {
  var theme = _ref37.theme;
  return theme.fontSize.XSmall;
});
var QuarentinePromoTagMobile = _styledComponents.default.div.withConfig({
  displayName: "OptionsAndBenefitsInfo__QuarentinePromoTagMobile",
  componentId: "sc-gpzfpd-8"
})(["display:flex;background:", ";color:", ";font-style:normal;margin-left:", ";font-size:", ";display:flex;align-content:center;padding-left:", ";padding-top:", ";padding-bottom:", ";font-size:", ";width:", ";"], function (_ref38) {
  var theme = _ref38.theme,
    background = _ref38.background;
  return theme.colors[background];
}, function (_ref39) {
  var theme = _ref39.theme,
    color = _ref39.color;
  return theme.colors[color];
}, function (_ref40) {
  var theme = _ref40.theme;
  return theme.space.semi;
}, function (_ref41) {
  var theme = _ref41.theme;
  return theme.space.micro;
}, function (_ref42) {
  var theme = _ref42.theme;
  return theme.space.XSmall;
}, function (_ref43) {
  var theme = _ref43.theme;
  return theme.space.micro;
}, function (_ref44) {
  var theme = _ref44.theme;
  return theme.space.micro;
}, function (_ref45) {
  var theme = _ref45.theme;
  return theme.fontSize.XSmall;
}, function (_ref46) {
  var theme = _ref46.theme;
  return theme.space.semiXXXLarge;
});
var IconWrapper = _styledComponents.default.div.withConfig({
  displayName: "OptionsAndBenefitsInfo__IconWrapper",
  componentId: "sc-gpzfpd-9"
})(["color:", ";margin-left:5px;margin-right:15px;"], function (_ref47) {
  var theme = _ref47.theme;
  return theme.colors.tertiary;
});
var PayLaterText = _styledComponents.default.div.withConfig({
  displayName: "OptionsAndBenefitsInfo__PayLaterText",
  componentId: "sc-gpzfpd-10"
})(["font-size:", ";font-weight:", ";margin-top:-5px;margin-bottom:5px;color:", ";"], function (_ref48) {
  var theme = _ref48.theme;
  return theme.fontSize.XSmall;
}, function (_ref49) {
  var theme = _ref49.theme;
  return theme.fontWeight.normal;
}, function (_ref50) {
  var theme = _ref50.theme;
  return theme.colors.greyDark;
});
var CancellationSubText = _styledComponents.default.div.withConfig({
  displayName: "OptionsAndBenefitsInfo__CancellationSubText",
  componentId: "sc-gpzfpd-11"
})(["font-size:", ";font-weight:", ";color:", ";"], function (_ref51) {
  var theme = _ref51.theme;
  return theme.fontSize.XSmall;
}, function (_ref52) {
  var theme = _ref52.theme;
  return theme.fontWeight.normal;
}, function (_ref53) {
  var theme = _ref53.theme;
  return theme.colors.blue;
});
var TextWrapper = _styledComponents.default.div.withConfig({
  displayName: "OptionsAndBenefitsInfo__TextWrapper",
  componentId: "sc-gpzfpd-12"
})(["font-size:", ";color:", ";padding-bottom:5px;"], function (_ref54) {
  var theme = _ref54.theme;
  return theme.fontSize.normal;
}, function (_ref55) {
  var theme = _ref55.theme;
  return theme.colors.greyDark;
});
var CancellationTextWrapper = _styledComponents.default.div.withConfig({
  displayName: "OptionsAndBenefitsInfo__CancellationTextWrapper",
  componentId: "sc-gpzfpd-13"
})(["font-size:", ";color:", ";padding-bottom:5px;"], function (_ref56) {
  var theme = _ref56.theme;
  return theme.fontSize.normal;
}, function (_ref57) {
  var theme = _ref57.theme;
  return theme.colors.blue;
});
var ContentWrapper = _styledComponents.default.div.withConfig({
  displayName: "OptionsAndBenefitsInfo__ContentWrapper",
  componentId: "sc-gpzfpd-14"
})(["display:flex;flex-direction:column;"]);
var Title = _styledComponents.default.div.withConfig({
  displayName: "OptionsAndBenefitsInfo__Title",
  componentId: "sc-gpzfpd-15"
})(["font-family:", ";font-size:", ";font-weight:", ";line-height:", ";color:", ";margin-bottom:", ";"], function (_ref58) {
  var theme = _ref58.theme;
  return theme.fontFamily.default;
}, function (_ref59) {
  var theme = _ref59.theme;
  return theme.fontSize.normal;
}, function (_ref60) {
  var theme = _ref60.theme;
  return theme.fontWeight.medium;
}, function (_ref61) {
  var theme = _ref61.theme;
  return theme.lineHeight.XLarge;
}, function (_ref62) {
  var theme = _ref62.theme;
  return theme.colors.neutral;
}, function (_ref63) {
  var theme = _ref63.theme;
  return theme.space.micro;
});
var ToolTipContainer = _styledComponents.default.div.withConfig({
  displayName: "OptionsAndBenefitsInfo__ToolTipContainer",
  componentId: "sc-gpzfpd-16"
})(["display:flex;align-items:center;margin-bottom:5px;"]);
var ToolTipContent = _styledComponents.default.div.withConfig({
  displayName: "OptionsAndBenefitsInfo__ToolTipContent",
  componentId: "sc-gpzfpd-17"
})(["display:flex;flex-flow:column wrap;"]);
var ToolTipIcon = _styledComponents.default.div.withConfig({
  displayName: "OptionsAndBenefitsInfo__ToolTipIcon",
  componentId: "sc-gpzfpd-18"
})(["display:flex;flex-direction:row;align-items:center;margin-right:5px;"]);
var FomoMessageContainer = _styledComponents.default.div.withConfig({
  displayName: "OptionsAndBenefitsInfo__FomoMessageContainer",
  componentId: "sc-gpzfpd-19"
})(["display:grid;grid-template-columns:34px 1fr;grid-template-rows:34px;width:fit-content;align-items:center;background:#fbebe9;padding-right:10px;white-space:nowrap;"]);
var FomoMessage = _styledComponents.default.div.withConfig({
  displayName: "OptionsAndBenefitsInfo__FomoMessage",
  componentId: "sc-gpzfpd-20"
})(["font-family:DM Sans;font-size:12px;font-weight:500;line-height:18px;letter-spacing:0em;text-align:left;color:#c92d21;padding-left:10px;"]);
var RightMostItem = _styledComponents.default.div.withConfig({
  displayName: "OptionsAndBenefitsInfo__RightMostItem",
  componentId: "sc-gpzfpd-21"
})(["justify-self:end;align-items:center;height:15px;width:15px;"]);
var LowInventoryIcon = _styledComponents.default.div.withConfig({
  displayName: "OptionsAndBenefitsInfo__LowInventoryIcon",
  componentId: "sc-gpzfpd-22"
})(["height:16px;width:28px;padding-left:4px;padding-top:3px;"]);
var LowInventoryMessage = _styledComponents.default.div.withConfig({
  displayName: "OptionsAndBenefitsInfo__LowInventoryMessage",
  componentId: "sc-gpzfpd-23"
})(["font-family:'DM Sans',sans-serif;font-size:16px;font-weight:400;line-height:24px;letter-spacing:0em;text-align:left;color:#d97f00;"]);
var PromoContainer = _styledComponents.default.div.withConfig({
  displayName: "OptionsAndBenefitsInfo__PromoContainer",
  componentId: "sc-gpzfpd-24"
})(["display:flex;align-items:center;margin-bottom:12px;"]);
var BogoPromowrapperweb = _styledComponents.default.div.withConfig({
  displayName: "OptionsAndBenefitsInfo__BogoPromowrapperweb",
  componentId: "sc-gpzfpd-25"
})(["height:14%;padding-top:8px;&:hover{background:", ";}margin-left:4px;"], function (_ref64) {
  var theme = _ref64.theme;
  return "".concat(theme.backgroundColor.primary);
});
var BogoMessageLabel = _styledComponents.default.div.withConfig({
  displayName: "OptionsAndBenefitsInfo__BogoMessageLabel",
  componentId: "sc-gpzfpd-26"
})(["font-family:DM Sans;font-size:16px;font-style:normal;font-weight:400;color:", ";margin-left:10px;"], function (_ref65) {
  var theme = _ref65.theme;
  return theme.colors.blueDark;
});
var OptionsAndBenefitsInfo = function OptionsAndBenefitsInfo(_ref66) {
  var rateName = _ref66.rateName,
    isShowRateName = _ref66.isShowRateName,
    theme = _ref66.theme,
    isMobile = _ref66.isMobile,
    index = _ref66.index,
    option = _ref66.option,
    freeCancellationText = _ref66.freeCancellationText,
    freeCancellation = _ref66.freeCancellation,
    payLater = _ref66.payLater,
    payLaterText = _ref66.payLaterText,
    payAtHotelText = _ref66.payAtHotelText,
    nonRefundable = _ref66.nonRefundable,
    partiallyRefundable = _ref66.partiallyRefundable,
    payAtHotel = _ref66.payAtHotel,
    instantConfirmationText = _ref66.instantConfirmationText,
    recommendedText = _ref66.recommendedText,
    flierDiscountText = _ref66.flierDiscountText,
    isSingleOption = _ref66.isSingleOption,
    promoTitle = _ref66.promoTitle,
    amenities = _ref66.amenities,
    accessible = _ref66.accessible,
    discountType = _ref66.discountType,
    refundType = _ref66.refundType,
    withTooltip = _ref66.withTooltip,
    toolTipCancellationHeaderText = _ref66.toolTipCancellationHeaderText,
    toolTipCancellationBodyText = _ref66.toolTipCancellationBodyText,
    isNonRefundable = _ref66.isNonRefundable,
    isFreeCancellation = _ref66.isFreeCancellation,
    messageFOMO = _ref66.messageFOMO,
    isSoldOut = _ref66.isSoldOut,
    lowInventoryFOMO = _ref66.lowInventoryFOMO,
    isBogoPromoEnabled = _ref66.isBogoPromoEnabled,
    bogoMessage = _ref66.bogoMessage,
    payNowMessage = _ref66.payNowMessage,
    isPayNowEnabled = _ref66.isPayNowEnabled,
    move = _ref66.move;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var QuarentineDiscountType = 'quarantine_deal';
  var getObjectMessage = function getObjectMessage(obj) {
    var values = Object.values(obj);
    var firstValue = values[0]; // Assuming there's only one property in the object
    var message = firstValue ? firstValue.message : null;
    return message;
  };

  // const displayedBedGroups = bedGroupsOptions.map((bedGroup) => ({
  //   value: bedGroup.id,
  //   label: getRoomBedTypeAndRoomSize({
  //     bedSize: bedGroup.description,
  //     squareMeterArea: bedGroup.squareMeterArea,
  //   }),
  // }));

  var getToolTipContent = function getToolTipContent() {
    return /*#__PURE__*/_react.default.createElement(ToolTipContent, null, /*#__PURE__*/_react.default.createElement(Title, null, toolTipCancellationHeaderText || _constants.TRANSLATION.header), /*#__PURE__*/_react.default.createElement(Content, null, toolTipCancellationBodyText || _constants.TRANSLATION.bodyText));
  };
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(OptionsAndBenefitsWrapper, {
      isMobile: isMobile
    }, !isMobile && /*#__PURE__*/_react.default.createElement(RateOrderWrapper, null, !isSingleOption ? /*#__PURE__*/_react.default.createElement(RateOrder, {
      isHasTag: ((0, _Utils.isNotEmpty)(recommendedText) || (0, _Utils.isNotEmpty)(flierDiscountText)) && !isSingleOption,
      isMobile: isMobile
    }, isShowRateName && rateName ? rateName : "".concat(option, " ").concat(index + 1)) : /*#__PURE__*/_react.default.createElement(RateOrder, {
      isMobile: isMobile
    }, " ", isShowRateName && rateName ? rateName : '', " "), !isSingleOption && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _Utils.isNotEmpty)(recommendedText) && /*#__PURE__*/_react.default.createElement(TagWrapper, {
      color: move && 'oldSecondary',
      borderRadius: move && 'XXnormal'
    }, recommendedText), (0, _Utils.isNotEmpty)(flierDiscountText) && /*#__PURE__*/_react.default.createElement(TagWrapper, {
      color: move && 'oldSecondary',
      borderRadius: move && 'XXnormal'
    }, flierDiscountText))), isBogoPromoEnabled && bogoMessage && /*#__PURE__*/_react.default.createElement(BogoPromowrapperweb, null, /*#__PURE__*/_react.default.createElement(PromoContainer, null, /*#__PURE__*/_react.default.createElement(_BogoIcon.default, null), /*#__PURE__*/_react.default.createElement(BogoMessageLabel, null, bogoMessage))), isPayNowEnabled ? /*#__PURE__*/_react.default.createElement(BogoPromowrapperweb, null, /*#__PURE__*/_react.default.createElement(PromoContainer, null, /*#__PURE__*/_react.default.createElement(_SellIcon.default, null), /*#__PURE__*/_react.default.createElement(BogoMessageLabel, null, payNowMessage))) : null, Boolean(isFreeCancellation) && refundType !== 'partialRefund' && /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row'
      }
    }, withTooltip ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(IconWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: "CheckIcon",
      color: "blue"
    })), /*#__PURE__*/_react.default.createElement(ContentWrapper, null, /*#__PURE__*/_react.default.createElement(CancellationTextWrapper, null, freeCancellation), /*#__PURE__*/_react.default.createElement(_Popover.default, {
      theme: theme,
      accessible: accessible,
      asToolTip: true,
      content: getToolTipContent(),
      position: isMobile ? _constants.CONTENT_POSITION.TOP : _constants.CONTENT_POSITION.RIGHT,
      trigger: isMobile ? _constants.TRIGGERS.click : _constants.TRIGGERS.hover,
      width: 250
    }, /*#__PURE__*/_react.default.createElement(ToolTipContainer, null, /*#__PURE__*/_react.default.createElement(ToolTipIcon, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: "InfoIcon",
      color: "blue"
    })), /*#__PURE__*/_react.default.createElement(CancellationSubText, null, freeCancellationText))))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(IconWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: "CheckIcon",
      color: "#067E41"
    })), /*#__PURE__*/_react.default.createElement(ContentWrapper, null, /*#__PURE__*/_react.default.createElement(TextWrapper, null, freeCancellation), /*#__PURE__*/_react.default.createElement(PayLaterText, null, freeCancellationText)))), Boolean(isNonRefundable) && /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row'
      }
    }, /*#__PURE__*/_react.default.createElement(IconWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: "CheckIcon",
      color: "#067E41"
    })), /*#__PURE__*/_react.default.createElement(ContentWrapper, null, /*#__PURE__*/_react.default.createElement(TextWrapper, null, nonRefundable))), amenities === null || amenities === void 0 ? void 0 : amenities.map(function (ele) {
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'row'
        }
      }, /*#__PURE__*/_react.default.createElement(IconWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        icon: "CheckIcon",
        color: "#067E41"
      })), /*#__PURE__*/_react.default.createElement(TextWrapper, null, ele.name));
    }), (0, _Utils.isNotEmpty)(payLater) && /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row'
      }
    }, /*#__PURE__*/_react.default.createElement(IconWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: "CheckIcon",
      color: "#067E41"
    })), /*#__PURE__*/_react.default.createElement(ContentWrapper, null, /*#__PURE__*/_react.default.createElement(TextWrapper, null, payLater), /*#__PURE__*/_react.default.createElement(PayLaterText, null, payLaterText))), refundType === 'partialRefund' && /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row'
      }
    }, /*#__PURE__*/_react.default.createElement(IconWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: "CheckIcon",
      color: "#067E41"
    })), /*#__PURE__*/_react.default.createElement(TextWrapper, null, partiallyRefundable)), (0, _Utils.isNotEmpty)(payAtHotel) && /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row'
      }
    }, /*#__PURE__*/_react.default.createElement(IconWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: "CheckIcon",
      color: "#067E41"
    })), /*#__PURE__*/_react.default.createElement(ContentWrapper, null, /*#__PURE__*/_react.default.createElement(TextWrapper, null, payAtHotel), /*#__PURE__*/_react.default.createElement(PayLaterText, null, payAtHotelText))), (0, _Utils.isNotEmpty)(instantConfirmationText) && /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row'
      }
    }, /*#__PURE__*/_react.default.createElement(IconWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: "CheckIcon",
      color: "#067E41"
    })), /*#__PURE__*/_react.default.createElement(TextWrapper, null, instantConfirmationText)), isMobile && promoTitle && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _Utils.isNotEmpty)(QuarentineDiscountType) && discountType === QuarentineDiscountType ? /*#__PURE__*/_react.default.createElement(QuarentinePromoTagMobile, {
      background: "blue",
      color: "default"
    }, promoTitle) : /*#__PURE__*/_react.default.createElement(PromoTagMobile, {
      color: "blue"
    }, "\xA0 ", promoTitle, " \xA0")), !isMobile && promoTitle && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _Utils.isNotEmpty)(QuarentineDiscountType) && discountType === QuarentineDiscountType ? /*#__PURE__*/_react.default.createElement(Promo, {
      color: "blue"
    }, /*#__PURE__*/_react.default.createElement(PromoTag, {
      background: "blue",
      color: "default"
    }, promoTitle)) :
    /*#__PURE__*/
    // #2f73d2
    _react.default.createElement(Promo, {
      color: "secondaryBlue"
    }, /*#__PURE__*/_react.default.createElement(PromoTag, {
      background: "blueLight",
      color: "blue"
    }, "\xA0 ", promoTitle, " \xA0"))), isSoldOut && /*#__PURE__*/_react.default.createElement(FomoMessageContainer, null, /*#__PURE__*/_react.default.createElement(RightMostItem, null, /*#__PURE__*/_react.default.createElement(_Clock.default, null)), /*#__PURE__*/_react.default.createElement(FomoMessage, null, messageFOMO)), getObjectMessage(lowInventoryFOMO) && /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row'
      }
    }, /*#__PURE__*/_react.default.createElement(LowInventoryIcon, null, /*#__PURE__*/_react.default.createElement(_TrendingDown.default, null)), /*#__PURE__*/_react.default.createElement(LowInventoryMessage, null, getObjectMessage(lowInventoryFOMO)))));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
OptionsAndBenefitsInfo.propTypes = _RoomCard.OptionsAndBenefitsInfoPropTypes;
OptionsAndBenefitsInfo.defaultProps = _RoomCard.OptionsAndBenefitsInfoDefaultValues;
var _default = OptionsAndBenefitsInfo;
exports.default = _default;